import Excel from 'exceljs';
import FileSaver from 'file-saver';
import _ from 'lodash';

const formatHeaderRow = (row, worksheet) => {
  row.alignment = { horizontal: 'center' };
  row.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'eeeeee' },
  };
  row.border = { bottom: { style: 'thin' }, top: { style: 'thin' } };
  worksheet.mergeCells(row.number, 1, row.number, worksheet.columnCount);
};

const downloadExcelFile = async (workbook) => {
  const fileName = workbook.worksheets[0].name;
  const buffer = await workbook.xlsx.writeBuffer();
  const type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const blob = new Blob([buffer], { type });
  return FileSaver.saveAs(blob, `${fileName}-${new Date().getTime()}.xlsx`);
};

const downloadCSVFile = async (workbook) => {
  const fileName = workbook.worksheets[0].name;
  const buffer = await workbook.csv.writeBuffer();
  const blob = new Blob([buffer], { type: 'text/csv' });
  return FileSaver.saveAs(blob, `${fileName}-${new Date().getTime()}.csv`);
};

export default {
  downloadDispenseLogsExcel(json, columnDefinitions, headerTable, fileName) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    headerTable.forEach((header) => {
      worksheet.addRow(header);
    });

    worksheet.columns = columnDefinitions.map((header) => {
      return { header: '', key: header.text, width: 25 };
    });

    worksheet.addRow(
      columnDefinitions.map((header) => {
        return header.text;
      }),
    );

    const headerRow = worksheet.getRow(14);
    headerRow.font = { bold: true };
    headerRow.border = { bottom: { style: 'thin' } };

    json.forEach((data) => {
      worksheet.addRow(data);
    });

    return downloadExcelFile(workbook);
  },

  downloadDispenseLogsCSV(json, headers, fileName) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    worksheet.columns = headers.map((header) => {
      return { header: header.text, key: header.text };
    });

    json.forEach((data) => {
      worksheet.addRow(data);
    });

    return downloadCSVFile(workbook);
  },

  // ////////////////////////////////////////////

  downloadConsumptionExcel(json, columnDefinitions, headerTable, fileName) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    headerTable.forEach((header) => {
      worksheet.addRow(header);
    });

    worksheet.columns = columnDefinitions.groups.map((header) => {
      return { header: '', key: header.text, width: 25 };
    });

    const headerRow = worksheet.addRow(
      columnDefinitions.groups.map((header) => {
        return header.text;
      }),
    );

    headerRow.font = { bold: true };

    const { groups, apps } = json;

    _.forOwn(groups, (groupValue, groupKey) => {
      const groupTitleRow = worksheet.addRow([groupKey]);
      formatHeaderRow(groupTitleRow, worksheet);

      const rows = groupValue.map((value) => {
        return worksheet.addRow(value);
      });
      _.last(rows).font = { bold: true };
    });

    const appsTitleRow = worksheet.addRow(['Applications']);
    formatHeaderRow(appsTitleRow, worksheet);

    const appRows = apps.map((value) => {
      return worksheet.addRow(value);
    });

    _.last(appRows).font = { bold: true };

    return downloadExcelFile(workbook);
  },

  downloadConsumptionCSV(json, columnDefinitions, fileName) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(fileName);

    worksheet.columns = columnDefinitions.groups.map((header) => {
      return { header: header.text, key: header.text };
    });

    const { apps } = json;

    apps.forEach((value) => {
      return worksheet.addRow(value);
    });

    return downloadCSVFile(workbook);
  },
};
